import { __extends, __assign, __rest } from 'tslib';
import { useLocalization } from '@shared-ui/localization-context';
import * as React from 'react';
import { useState, useEffect } from 'react';
import { UitkLink } from 'uitk-react-link';
import { classNames } from 'uitk-react-utils';
import { UitkButton } from 'uitk-react-button';
import { UitkIcon } from 'uitk-react-icons';

var UitkExpandoPeekAnalyticsId;
(function (UitkExpandoPeekAnalyticsId) {
    UitkExpandoPeekAnalyticsId["EXPAND"] = "opened";
    UitkExpandoPeekAnalyticsId["COLLAPSE"] = "closed";
})(UitkExpandoPeekAnalyticsId || (UitkExpandoPeekAnalyticsId = {}));
var ExpandoPeek = /** @class */ (function (_super) {
    __extends(ExpandoPeek, _super);
    function ExpandoPeek(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            collapsedHeight: 0,
            expandedHeight: 0,
            mounted: false,
            prevProps: {},
            showContent: props.show
        };
        _this.handleResize = _this.handleResize.bind(_this);
        _this.toggleContent = _this.toggleContent.bind(_this);
        return _this;
    }
    ExpandoPeek.getDerivedStateFromProps = function (nextProps, prevState) {
        var prevProps = prevState.prevProps;
        var showContent = prevProps.show === nextProps.show ? prevState.showContent : nextProps.show;
        return {
            // Store the previous props in state
            // getDerivedStateFormProps in 16.3.2 is buggy so additional checks are required
            prevProps: nextProps,
            showContent: showContent
        };
    };
    ExpandoPeek.prototype.componentDidMount = function () {
        window.addEventListener('resize', this.handleResize);
        // Init after js takes over
        this.setState({
            mounted: true
        });
    };
    ExpandoPeek.prototype.componentDidUpdate = function (prevProps, prevState) {
        // Only run after init
        if (!prevState.mounted) {
            this.handleResize();
        }
    };
    ExpandoPeek.prototype.componentWillUnmount = function () {
        window.removeEventListener('resize', this.handleResize);
    };
    ExpandoPeek.prototype.handleResize = function () {
        var _a = this.props, collapseHeight = _a.collapseHeight, threshold = _a.threshold;
        var newThreshold = threshold || collapseHeight || 96;
        this.setState({
            collapsedHeight: newThreshold,
            expandedHeight: this.inner.clientHeight
        });
    };
    ExpandoPeek.prototype.toggleContent = function () {
        console.warn('Passing `show` as a prop and using internal state is deprecated. Please modify state by passing `isVisible` and `handleClick` as props');
        var showContent = this.state.showContent;
        this.setState({
            showContent: !showContent
        });
    };
    ExpandoPeek.prototype.renderExpandoButton = function () {
        var _a = this.props, expandLabel = _a.expandLabel, collapseLabel = _a.collapseLabel, l10n = _a.l10n, handleClick = _a.handleClick, isVisible = _a.isVisible, analytics = _a.analytics;
        var showContent = this.state.showContent;
        var toggleOn = isVisible || showContent;
        var btnText = toggleOn
            ? collapseLabel || l10n.formatText('expando.collapseLabel')
            : expandLabel || l10n.formatText('expando.expandLabel');
        var localAnalyticsId = toggleOn ? UitkExpandoPeekAnalyticsId.COLLAPSE : UitkExpandoPeekAnalyticsId.EXPAND;
        var btnClass = 'uitk-expando-peek-link theme-primary';
        var controlClasses = classNames('uitk-expando-peek-control', {
            'uitk-expando-peek-control-active': toggleOn
        });
        return (React.createElement("div", { className: controlClasses, "aria-hidden": true },
            React.createElement(UitkLink, { "aria-expanded": toggleOn, className: btnClass, analytics: analytics && __assign({ localAnalyticsId: localAnalyticsId }, analytics) },
                React.createElement("button", { type: "button", onClick: handleClick && typeof handleClick === 'function' ? handleClick : this.toggleContent }, btnText))));
    };
    ExpandoPeek.prototype.render = function () {
        var _a, _b, _c;
        var _this = this;
        var _d = this.props, className = _d.className, children = _d.children, collapseHeight = _d.collapseHeight, isVisible = _d.isVisible, _e = _d.hideScrim, hideScrim = _e === void 0 ? false : _e;
        var _f = this.state, mounted = _f.mounted, collapsedHeight = _f.collapsedHeight, expandedHeight = _f.expandedHeight, showContent = _f.showContent;
        var toggleOn = isVisible || showContent;
        var wrapperClasses = classNames('uitk-expando-peek', className, (_a = {},
            _a["uitk-expando-peek-mounted"] = mounted,
            _a));
        // Disable if content is smaller than the expandedHeight
        var showExpando = collapsedHeight < expandedHeight;
        var mainClass = 'uitk-expando-peek-main';
        var mainClasses = classNames(mainClass, (_b = {},
            _b[mainClass + "-active"] = toggleOn,
            _b), (_c = {},
            _c[mainClass + "-inactive"] = !toggleOn && showExpando,
            _c));
        var divStyle;
        if (mounted && !toggleOn && showExpando && collapseHeight) {
            var gradientTopHeight = collapseHeight - 60;
            var gradientStyle = hideScrim
                ? ''
                : "-webkit-linear-gradient(270deg, rgb(255, 255, 255) " + gradientTopHeight + "px, rgba(255, 255, 255, 0.85) 62%, rgba(255, 255, 255, 0.7) 70%, rgba(255, 255, 255, 0.3) 87%, rgba(255, 255, 255, 0.18) 92%, rgba(255, 255, 255, 0.04) 97%, rgba(255, 255, 255, 0) 100%)";
            divStyle = {
                webkitMaskImage: gradientStyle,
                maxHeight: collapseHeight /* Stylelint-disable */
            };
        }
        var domRef = function (main) {
            _this.main = main;
        };
        return (React.createElement("div", { className: wrapperClasses },
            React.createElement("div", { className: mainClasses, style: divStyle, ref: domRef },
                React.createElement("div", { className: "uitk-expando-peek-inner", ref: function (inner) {
                        _this.inner = inner;
                    } }, children)),
            mounted && showExpando && this.renderExpandoButton()));
    };
    ExpandoPeek.displayName = 'UitkExpandoPeek';
    ExpandoPeek.defaultProps = {
        collapseHeight: 96,
        isVisible: false,
        show: false
    };
    return ExpandoPeek;
}(React.PureComponent));
var UitkExpandoPeek = function (props) {
    var l10n = useLocalization();
    return React.createElement(ExpandoPeek, __assign({ l10n: l10n }, props));
};

/**
 * This is a simple expander that when clicked, will show more text or other
 * children. Makes use of inversion of control.
 * We make use of a description list:
 *
 * @see {@link https://developer.mozilla.org/en-US/docs/Web/HTML/Element/dl}
 * Accessibility:
 * @see {@link http://wwwexpediacom.a11y-demos-web.us-west-2.test.expedia.com/pages/components/toggles}
 */
// eslint-disable-next-line prefer-arrow/prefer-arrow-functions
function UitkExpandoList(_a) {
    var children = _a.children, className = _a.className, props = __rest(_a, ["children", "className"]);
    var cssClassNames = classNames('uitk-expando-list', className);
    return (React.createElement("section", __assign({ className: cssClassNames }, props), children));
}
UitkExpandoList.displayName = 'UitkExpandoList';

var ExpandoButtonArrowPosition;
(function (ExpandoButtonArrowPosition) {
    ExpandoButtonArrowPosition[ExpandoButtonArrowPosition["LEFT_TO_THE_TITLE"] = 0] = "LEFT_TO_THE_TITLE";
    ExpandoButtonArrowPosition[ExpandoButtonArrowPosition["RIGHT_TO_THE_TITLE"] = 1] = "RIGHT_TO_THE_TITLE";
})(ExpandoButtonArrowPosition || (ExpandoButtonArrowPosition = {}));
var ExpandoButtonTitleType;
(function (ExpandoButtonTitleType) {
    ExpandoButtonTitleType[ExpandoButtonTitleType["UITK_LINK_TYPE_200"] = 0] = "UITK_LINK_TYPE_200";
    ExpandoButtonTitleType[ExpandoButtonTitleType["UITK_LINK_TYPE_300"] = 1] = "UITK_LINK_TYPE_300";
    ExpandoButtonTitleType[ExpandoButtonTitleType["UITK_BUTTON"] = 2] = "UITK_BUTTON";
})(ExpandoButtonTitleType || (ExpandoButtonTitleType = {}));
var UitkExpandoButtonTitleAnalyticsId;
(function (UitkExpandoButtonTitleAnalyticsId) {
    UitkExpandoButtonTitleAnalyticsId["EXPAND"] = "opened";
    UitkExpandoButtonTitleAnalyticsId["COLLAPSE"] = "closed";
})(UitkExpandoButtonTitleAnalyticsId || (UitkExpandoButtonTitleAnalyticsId = {}));
/**
 * This is a generic expando button component with an arrow. It consists of a title and an arrow. The expansion needs to be
 * managed by the user of this component by using the {@code isExpanded} and the {@code handleClick} properties.
 *
 * @param handleClick emits a click event when the title is clicked
 * @param className the provided classes to be used in the title
 */
var UitkExpandoButton = /** @class */ (function (_super) {
    __extends(UitkExpandoButton, _super);
    function UitkExpandoButton() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    UitkExpandoButton.prototype.buildUitkLinkType = function (size, buttonAttributes, buttonBody) {
        var tag = buttonAttributes.tag, btnAttributes = __rest(buttonAttributes, ["tag"]);
        var Tag = tag || 'button';
        return (React.createElement(UitkLink, __assign({}, btnAttributes, { size: size }),
            React.createElement(Tag, { type: tag === 'button' ? 'button' : undefined }, buttonBody)));
    };
    UitkExpandoButton.prototype.render = function () {
        var _a = this.props, expandoTitleType = _a.expandoTitleType, expandoTitle = _a.expandoTitle, arrowPosition = _a.arrowPosition, className = _a.className, analytics = _a.analytics, handleClick = _a.handleClick, isExpanded = _a.isExpanded, isExpandoCard = _a.isExpandoCard, expandoSubtitle = _a.expandoSubtitle, expandoTitleSize = _a.expandoTitleSize, accessibilityLabel = _a.accessibilityLabel, buttonRef = _a.buttonRef, attributes = __rest(_a, ["expandoTitleType", "expandoTitle", "arrowPosition", "className", "analytics", "handleClick", "isExpanded", "isExpandoCard", "expandoSubtitle", "expandoTitleSize", "accessibilityLabel", "buttonRef"]);
        var localAnalyticsId = isExpanded
            ? UitkExpandoButtonTitleAnalyticsId.COLLAPSE
            : UitkExpandoButtonTitleAnalyticsId.EXPAND;
        var accessibleExpandoTitle = expandoSubtitle ? expandoTitle + ". " + expandoSubtitle : expandoTitle;
        var accessibleLabel = accessibilityLabel || accessibleExpandoTitle;
        var buttonAttributes = __assign({ analytics: analytics && __assign({ localAnalyticsId: localAnalyticsId }, analytics), 'aria-expanded': attributes.tag && attributes.tag !== 'summary' ? isExpanded : undefined, onClick: attributes.tag && attributes.tag !== 'summary' ? handleClick : undefined }, attributes);
        var buttonIcon = (React.createElement(UitkIcon, { className: "uitk-expando-button-icon" + (isExpanded ? ' uitk-expando-button-icon-active' : ''), "data-testid": isExpanded ? 'uitk-expando-button-icon-expanded' : undefined, name: "expand_more" }));
        var buttonTextClassNames = classNames('uitk-expando-button-title', isExpandoCard ? expandoTitleSize : '', className);
        var expandoCardSubtitle = classNames('uitk-expando-card-subtitle', className);
        var buttonBody = (React.createElement(React.Fragment, null,
            arrowPosition === ExpandoButtonArrowPosition.LEFT_TO_THE_TITLE && buttonIcon,
            React.createElement("span", { className: "is-visually-hidden", "data-a11ytext": "true" }, accessibleLabel),
            React.createElement("span", { className: buttonTextClassNames, "aria-hidden": true },
                expandoTitle,
                isExpandoCard && expandoSubtitle && React.createElement("p", { className: expandoCardSubtitle }, expandoSubtitle)),
            arrowPosition === ExpandoButtonArrowPosition.RIGHT_TO_THE_TITLE && buttonIcon));
        // Enum for UitkLinkTypeSize has been deprecated, Link type 200 is 'small' and type 300 is 'medium' now.
        var uitkLinkType200 = this.buildUitkLinkType('small', buttonAttributes, buttonBody);
        var uitkLinkType300 = this.buildUitkLinkType('medium', buttonAttributes, buttonBody);
        var uitkButton = (React.createElement(UitkButton, __assign({}, buttonAttributes, { domRef: buttonRef }),
            React.createElement("div", { className: "uitk-expando-button-content" }, buttonBody)));
        var expandoButtonElement;
        switch (expandoTitleType) {
            case ExpandoButtonTitleType.UITK_BUTTON:
                expandoButtonElement = uitkButton;
                break;
            case ExpandoButtonTitleType.UITK_LINK_TYPE_200:
                expandoButtonElement = uitkLinkType200;
                break;
            case ExpandoButtonTitleType.UITK_LINK_TYPE_300:
                expandoButtonElement = uitkLinkType300;
                break;
        }
        return expandoButtonElement;
    };
    return UitkExpandoButton;
}(React.Component));

var getTestId$1 = function (testId, isOpen) { return (isOpen ? testId + "-expanded" : testId + "-collapsed"); };
var ExpandoListItemDefault = function (_a) {
    var analytics = _a.analytics, expandoDescription = _a.expandoDescription, expandoTitle = _a.expandoTitle, className = _a.className, isVisible = _a.isVisible, onToggle = _a.onToggle, props = __rest(_a, ["analytics", "expandoDescription", "expandoTitle", "className", "isVisible", "onToggle"]);
    var descriptionClassName = classNames(className, 'uitk-expando-list-description-legacy', { '--active': isVisible });
    return (React.createElement(React.Fragment, null,
        React.createElement(UitkExpandoButton, __assign({ "aria-expanded": isVisible, arrowPosition: ExpandoButtonArrowPosition.LEFT_TO_THE_TITLE, expandoTitleType: ExpandoButtonTitleType.UITK_BUTTON, expandoTitle: expandoTitle, isExpanded: isVisible, analytics: analytics, className: className, onClick: onToggle }, props)),
        React.createElement("div", { className: descriptionClassName, "data-testid": getTestId$1('uitk-expando-list-body', isVisible), "aria-hidden": !isVisible },
            React.createElement("div", { className: "uitk-expando-description-content" }, expandoDescription))));
};
ExpandoListItemDefault.displayName = 'ExpandoListItemDefault';

var getTestId = function (testId, isOpen) { return (isOpen ? testId + "-expanded" : testId + "-collapsed"); };
// eslint-disable-next-line prefer-arrow/prefer-arrow-functions
function useDetailsSupport() {
    var isClientRender = typeof window !== 'undefined';
    // eslint-disable-next-line react-hooks/exhaustive-deps
    return React.useMemo(function () { return isClientRender && !!(typeof document.createElement('details').open === 'boolean'); }, []);
}
var ExpandoListItemWithDetails = function (_a) {
    var analytics = _a.analytics, expandoDescription = _a.expandoDescription, expandoTitle = _a.expandoTitle, className = _a.className, isVisible = _a.isVisible, onToggle = _a.onToggle, props = __rest(_a, ["analytics", "expandoDescription", "expandoTitle", "className", "isVisible", "onToggle"]);
    var onToggleHandler = function (event) {
        if (event.currentTarget.open !== isVisible) {
            onToggle === null || onToggle === void 0 ? void 0 : onToggle();
        }
    };
    return (React.createElement("details", { open: isVisible, onToggle: onToggleHandler },
        React.createElement(UitkExpandoButton, __assign({ arrowPosition: ExpandoButtonArrowPosition.LEFT_TO_THE_TITLE, expandoTitleType: ExpandoButtonTitleType.UITK_BUTTON, expandoTitle: expandoTitle, isExpanded: isVisible, analytics: analytics, className: className, tag: "summary" }, props)),
        React.createElement("div", { className: "uitk-expando-list-body", "data-testid": getTestId('uitk-expando-list-body', isVisible) },
            React.createElement("div", { className: "uitk-expando-list-description" }, expandoDescription))));
};
ExpandoListItemWithDetails.displayName = 'ExpandoListItemWithDetails';

var UitkExpandoListItemControlled = function (props) {
    var isDetailsSupported = useDetailsSupport();
    if (isDetailsSupported) {
        return React.createElement(ExpandoListItemWithDetails, __assign({}, props));
    }
    return React.createElement(ExpandoListItemDefault, __assign({}, props));
};
UitkExpandoListItemControlled.displayName = 'UitkExpandoListItemControlled';

var UitkExpandoListItemUncontrolled = function (props) {
    var isVisible = props.isVisible;
    var _a = React.useState(isVisible), isOpen = _a[0], setIsOpen = _a[1];
    var isDetailsSupported = useDetailsSupport();
    var onToggleHandler = function () {
        setIsOpen(!isOpen);
    };
    if (isDetailsSupported) {
        return React.createElement(ExpandoListItemWithDetails, __assign({}, props, { isVisible: isOpen, onToggle: onToggleHandler }));
    }
    return React.createElement(ExpandoListItemDefault, __assign({}, props, { isVisible: isOpen, onToggle: onToggleHandler }));
};
UitkExpandoListItemUncontrolled.displayName = 'UitkExpandoListItemUncontrolled';

/**
 * This component contains a details disclosure which when clicked will expand and show a
 * hidden description. Expansion is determined by the boolean value of {@code isVisible}.
 *
 * @param className the provided classes to be used in both the title and the description
 *
 * In the case that the user disabled JavaScript, the details disclosure default behaviour
 * will be active. This is akin to the JavaScript enabled behaviour.
 */
var UitkExpandoListItem = function (props) {
    var onToggle = props.onToggle;
    var hasClick = !!onToggle;
    if (hasClick) {
        return React.createElement(UitkExpandoListItemControlled, __assign({}, props));
    }
    return React.createElement(UitkExpandoListItemUncontrolled, __assign({}, props));
};
UitkExpandoListItem.defaultProps = {
    isVisible: false
};
UitkExpandoListItem.displayName = 'UitkExpandoListItem';

var UitkExpandoLinkTypeSize;
(function (UitkExpandoLinkTypeSize) {
    UitkExpandoLinkTypeSize["TYPE_200"] = "TYPE_200";
    UitkExpandoLinkTypeSize["TYPE_300"] = "TYPE_300";
})(UitkExpandoLinkTypeSize || (UitkExpandoLinkTypeSize = {}));
var checkDetailsCompatible = function () { return !!(typeof document.createElement('details').open === 'boolean'); };
/**
 * This component contains a title which when clicked will expand and show a
 * hidden body. Expansion is controlled by native <details> element.
 *
 * @param type specifies the size of the title
 * @param isVisible sets the initial state of expando's content
 * @param onDetailsToggle listens into the content toggle event
 *
 * In the case that the user disabled JavaScript, the body will be shown
 * by default.
 */
var UitkExpandoLink = function (props) {
    var _a = useState(false), isOpen = _a[0], setIsOpen = _a[1];
    var _b = useState(true), isdetailsCompatible = _b[0], setIsdetailsCompatible = _b[1];
    var children = props.children, isVisible = props.isVisible, collapsedLabel = props.expandoTitle, _c = props.expandedLabel, expandedLabel = _c === void 0 ? collapsedLabel : _c, onDetailsToggle = props.onDetailsToggle, analytics = props.analytics, type = props.type, accessibilityLabel = props.accessibilityLabel, attributes = __rest(props, ["children", "isVisible", "expandoTitle", "expandedLabel", "onDetailsToggle", "analytics", "type", "accessibilityLabel"]);
    var _d = useState(isVisible ? expandedLabel : collapsedLabel), title = _d[0], setTitle = _d[1];
    var cssClassNames = 'uitk-expando-link';
    var onToggleHandler = function () {
        var openState = !isOpen;
        setIsOpen(openState);
        if (onDetailsToggle) {
            onDetailsToggle(openState);
        }
        setTitle(openState ? expandedLabel : collapsedLabel);
    };
    useEffect(function () {
        setIsdetailsCompatible(checkDetailsCompatible);
        !isdetailsCompatible && setIsOpen(!!isVisible);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isdetailsCompatible]);
    var ExpandoLinkItem = (React.createElement(React.Fragment, null,
        React.createElement(UitkExpandoButton, __assign({ analytics: analytics, arrowPosition: ExpandoButtonArrowPosition.RIGHT_TO_THE_TITLE, className: "uitk-expando-summary", expandoTitle: title, expandoTitleType: type === UitkExpandoLinkTypeSize.TYPE_200
                ? ExpandoButtonTitleType.UITK_LINK_TYPE_200
                : ExpandoButtonTitleType.UITK_LINK_TYPE_300, isExpanded: isOpen, onClick: onToggleHandler, accessibilityLabel: accessibilityLabel }, attributes), children),
        React.createElement("div", { className: "uitk-expando-link-body-legacy " + (isOpen ? '--active' : ''), "data-testid": isOpen ? 'uitk-expando-link-body-expanded' : 'uitk-expando-link-body-collapsed' }, children)));
    var ExpandoLinkItemDD = (React.createElement("details", { onToggle: onToggleHandler, open: isVisible, className: cssClassNames },
        React.createElement(UitkExpandoButton, __assign({ arrowPosition: ExpandoButtonArrowPosition.RIGHT_TO_THE_TITLE, className: "uitk-expando-summary", expandoTitleType: type === UitkExpandoLinkTypeSize.TYPE_200
                ? ExpandoButtonTitleType.UITK_LINK_TYPE_200
                : ExpandoButtonTitleType.UITK_LINK_TYPE_300, isExpanded: isOpen, expandoTitle: title, analytics: analytics, tag: "summary", accessibilityLabel: accessibilityLabel }, attributes), children),
        React.createElement("div", { className: "uitk-expando-link-body", "data-testid": isOpen ? 'uitk-expando-link-body-expanded' : 'uitk-expando-link-body-collapsed' }, children)));
    return isdetailsCompatible ? ExpandoLinkItemDD : ExpandoLinkItem;
};
UitkExpandoLink.defaultProps = {
    isVisible: false
};
UitkExpandoLink.displayName = 'UitkExpandoLink';

var UitkExpandoCardTypeSize;
(function (UitkExpandoCardTypeSize) {
    UitkExpandoCardTypeSize["TYPE_400"] = "uitk-type-400";
    UitkExpandoCardTypeSize["TYPE_500"] = "uitk-type-500";
    UitkExpandoCardTypeSize["TYPE_600"] = "uitk-type-600";
    UitkExpandoCardTypeSize["TYPE_700"] = "uitk-type-700";
})(UitkExpandoCardTypeSize || (UitkExpandoCardTypeSize = {}));
/**
 * This is a simple expander that when clicked, will show more text or other
 * children. Makes use of inversion of control.
 * We make use of a description list:
 *
 * @see {@link https://developer.mozilla.org/en-US/docs/Web/HTML/Element/dl}
 *
 * Accessibility:
 * @see {@link http://wwwexpediacom.a11y-demos-web.us-west-2.test.expedia.com/pages/components/toggles}
 */
var UitkExpandoCard = function (props) {
    var expandoTitle = props.expandoTitle, isVisible = props.isVisible, handleClick = props.handleClick, analytics = props.analytics, className = props.className, overflow = props.overflow, expandoSubtitle = props.expandoSubtitle, expandoTitleSize = props.expandoTitleSize, expandoDescription = props.expandoDescription, stid = props.stid, buttonRef = props.buttonRef;
    var cssClassNames = classNames('uitk-expando-card', className);
    var contentClassNames = classNames('uitk-expando-card-content', isVisible && 'active', overflow && 'uitk-expando-card-has-overflow');
    return (React.createElement("div", __assign({ className: cssClassNames }, (stid && { 'data-stid': stid })),
        React.createElement(UitkExpandoButton, { arrowPosition: ExpandoButtonArrowPosition.RIGHT_TO_THE_TITLE, expandoTitleType: ExpandoButtonTitleType.UITK_BUTTON, expandoTitle: expandoTitle, isExpanded: isVisible, handleClick: handleClick, analytics: analytics, className: className, tag: "button", isExpandoCard: true, expandoSubtitle: expandoSubtitle, expandoTitleSize: expandoTitleSize, buttonRef: buttonRef },
            React.createElement("div", { className: classNames('uitk-expando-card-description', className) }, expandoDescription)),
        React.createElement("div", { className: contentClassNames, "data-testid": isVisible ? 'uitk-expando-card-content-expanded' : 'uitk-expando-card-content-collapsed', "aria-hidden": !isVisible },
            React.createElement("div", { className: "uitk-expando-card-item" }, expandoDescription))));
};
UitkExpandoCard.defaultProps = {
    expandoTitleSize: UitkExpandoCardTypeSize.TYPE_400
};
UitkExpandoCard.displayName = 'UitkExpandoCard';

export { ExpandoPeek, UitkExpandoCard, UitkExpandoCardTypeSize, UitkExpandoLink, UitkExpandoLinkTypeSize, UitkExpandoList, UitkExpandoListItem, UitkExpandoPeek, UitkExpandoPeekAnalyticsId, checkDetailsCompatible };
